import React from 'react';

function ImageServicesInitial(props: any) {
  const { imageUrl } = props;
  return (
    <>
      <img className="imageContainer" src={imageUrl} alt="name" />
    </>
  );
}
export default ImageServicesInitial;
